<template>
 <div>
    <div>
      <h5 class="header-stripe">
        <span v-if="!collapseEnabled"> {{title}}</span>
        <div class="action" v-if="!isDisableEdit && !isDisableOnDispatched">
          <Button type="secondary" size="mini" v-if="showReject"
            :disabled="!enableReject"
            @click="rejectInspection">
            {{$t('INDENT_REJECT')}}
          </Button>
          <Button size="mini" type="primary" v-if="isApprove" @click="acceptTruckInspection">
            {{$t('INDENT_APPROVE')}}
          </Button>
          <Button type="primary" v-else size="mini"
            :disabled="!enableAccept" @click="acceptTruckInspection">
            {{$t('INDENT_ACCEPT')}}
          </Button>
      </div>
      </h5>
        <Row :gutter="10" type="flex" class="py-15">
          <Col :span="12" v-if="inspection && inspection.length">
            <Checkbox
              :disabled="isDisableEdit"
              :value="isCheckAllInspection" @input="changeCheckAllInspection" class="pb-5">
              <span class="text-capitalize text-md">Vehicle Inspected</span>
            </Checkbox>
                        <CheckboxGroup
                v-model="selectedInspection" type="flex-wrap">
              <Checkbox  :disabled="isDisableEdit" v-for="inspectionVal in inspection"
                :label="inspectionVal.name" :key="inspectionVal.name" class="colgrid-6 mx-0 pb-5">
                <Tooltip v-if="inspectionVal.description" popper-class="max-width"
                :open-delay="200" effect="dark" placement="bottom-start">
                <div slot="content">{{inspectionVal.description}}</div>
                <span  class="pointer">{{inspectionVal.label}}</span>
              </Tooltip>
              <template v-else>{{inspectionVal.label}}</template>
              </Checkbox>
            </CheckboxGroup>
          </Col>
          <Col :span="12" v-if="inspectionDocs && inspectionDocs.length">
            <Checkbox :disabled="isDisableEdit"
              :value="isCheckAllInspectionDocs" @input="changeCheckAllInspectionDocs" class="pb-5">
              <span class="text-capitalize text-md">Documents Inspected</span>
            </Checkbox>
            <CheckboxGroup v-model="selectedInspectionDoc" type="flex-wrap">
              <Checkbox
                v-for="inspection in inspectionDocs"
                :disabled="isDisableEdit"
                :label="inspection.name" :key="inspection.name" class="colgrid-6 mx-0 pb-5">
                <Ellipsis :text="inspection.label" :length="20" :expandedContext="inspection.label" />
              </Checkbox>
            </CheckboxGroup>
          </Col>
        </Row>
    </div>
    <!-- todo attachment -->
   
    <Row :gutter="20" type="flex" class="mt-20">
        <Col :span="12">
          <Form :inline="false" class="form-default">
            <FormItem label="Comments" class="mb-0 form-default">
                <Input type="textarea"
                :disabled="isDisableEdit && !isDispatched"
                placeholder="Add Comment"
                :rows="1" v-model="comments" />
            </FormItem>
          </Form>
        </Col>
        <Col :span="8">
          <p class="text-xs text-bold mt-0">{{$t('INDENT_INSPECTION_ATTACHMENT')}}</p>
          <AttachmentsPopup
            :attachments="inspectionAttachments"
            :maxAllowed="5"
            :multiple="true"
            :allowDelete="true"
            @addAttachments="addAttachments"
            @removeAttachments="removeAttachments"
            />
        </Col>
    </Row>
    <!-- list-tags -->
    <div v-if="gatePassEnabled">
      <p class="text-xs text-bold mt-15">{{$t('INDENT_GATE_PASS')}}</p>
      <AttachmentsPopup
          :attachments="gatePassAttachments"
          :maxAllowed="5"
          :multiple="false"
          :allowDelete="false"
          :disableUpload="true"
          :isGatePassDocument="true"
          />
    </div>
    <div class="mt-20" v-if="[4, 22, 24, 5].includes(indent.status) && hasNoCommentsError">
      <span class="text-red1">
        {{$t('INDENT_REASON_REJECTING_VEHICLE')}}
      </span>
    </div>
    <div class="mt-20" v-if="blacklistVehReason">
      <span class="text-red1">
          <svgicon  name="info-black" width="14" height="14" :original="true" />
          {{$t('INDENT_VEHICLE_NUMBER_BLACKLISTED')}} - {{blacklistVehReason}}
      </span>
    </div>
    <div class="mt-20" v-if="blacklistDriverReason">
      <span class="text-red1">
          <svgicon  name="info-black" width="14" height="14" :original="true" />
          {{$t('INDENT_DRIVER_NUMBER_BLACKLISTED')}} - {{blacklistDriverReason}}
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import { BlacklistStatus } from 'pando-constants';
import AttachmentsPopup from '@common/components/AttachmentsPopup';
import Ellipsis from '@common/components/Ellipsis';

export default {
  props: {
    collapseEnabled: {
      type: Boolean,
      default: false,
    },
    indent: {
      type: Object,
      default: () => {},
    },
    isDisableEdit: {
      type: Boolean,
      default: false,
    },
    showReject: {
      type: Boolean,
      default: true,
    },
    currentClientId: {
      type: String,
      default: null,
    },
    inspection: {
      type: Array,
      default: () => [],
    },
    inspectionDocs: {
      type: Array,
      default: () => [],
    },
    attachments: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: null
    },
    isVehicleInspectionAtSource: {
      type: Boolean,
      default: true
    },
    gatePassAttachment: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AttachmentsPopup,
    Ellipsis
  },
  data() {
    return {
      comments: '',
      selectedInspection: [],
      selectedInspectionDoc: [],
      BlacklistStatus,
      hasNoCommentsError: false,
      gatePassEnabled: this.gatePassAttachment && this.gatePassAttachment.length,
    };
  },
  async created() {
    let inspectionObj = this.indent.flow.inspection;
    if(!this.isVehicleInspectionAtSource) {
      inspectionObj = this.indent.flow.inspection_at_destination;
    }
    const orderInspection = inspectionObj && inspectionObj.inspection;
    const orderInspectionDoc = inspectionObj && inspectionObj.documents;
    const inspectionKeys = orderInspection ? Object.keys(orderInspection) : [];
    const inspectionDocKeys = orderInspectionDoc ? Object.keys(orderInspectionDoc) : [];
    this.selectedInspection = inspectionKeys.filter(key => orderInspection[key]);
    this.selectedInspectionDoc = inspectionDocKeys.filter(key => orderInspectionDoc[key]);
    this.comments = inspectionObj && inspectionObj.comments;
  },
  computed: {
    inspectionAttachments() {
      return this.attachments.map(val => {
        return Object.assign({
          url: val.attachment_url,
        }, val);
      })
    },
    gatePassAttachments() {
      return this.gatePassAttachment && this.gatePassAttachment.map(val => {
        return Object.assign({
          url: val.attachment_url,
        }, val);
      })
    },
    isCheckAllInspection() {
      return Boolean(this.selectedInspection.length === this.inspection.length);
    },
    isCheckAllInspectionDocs() {
      return Boolean(this.selectedInspectionDoc.length === this.inspectionDocs.length);
    },
    blacklistVehReason() {
      if (this.indent.vehicle && this.indent.vehicle.blacklist_details) {
        const vehicleBlacklist = this.indent.vehicle.blacklist_details;
        if (vehicleBlacklist.status === BlacklistStatus.BLACKLIST) {
          return vehicleBlacklist.reason;
        }
      }
      return null;
    },
    isDisableOnDispatched() {
      if(this.isVehicleInspectionAtSource) {
        return this.isDispatched;
      } else {
        return !this.isDispatched;
      }
    },
    isDispatched() {
      const orderStatus = this.indent.status;
      return this.$statusUtil.isDispatched(orderStatus) ||
        this.$statusUtil.isAfterDispatched(orderStatus);
    },
    blacklistDriverReason() {
      if (this.indent.driver && this.indent.driver.blacklist_details) {
        const driverBlacklist = this.indent.driver.blacklist_details;
        if (driverBlacklist.status === BlacklistStatus.BLACKLIST) {
          return driverBlacklist.reason;
        }
      }
      return null;
    },
    enableAccept() {
      const selectedInspection = Array.isArray(this.selectedInspection) ? this.selectedInspection : [];
      const selectedInspectionDoc = Array.isArray(this.selectedInspectionDoc) ? this.selectedInspectionDoc : [];
      const dbInspection = Array.isArray(this.inspection)
        ? this.inspection.filter(inspection => inspection.required).map(inspection => inspection.name)
        : [];
      const checkInspection = dbInspection.every(
        inspection => selectedInspection.includes(inspection)
      );
      const dbDocument = Array.isArray(this.inspectionDocs)
        ? this.inspectionDocs.filter(document => document.required).map(document => document.name)
        : [];
      const checkDocuments = dbDocument.every(
        document => selectedInspectionDoc.includes(document)
      );
      if(this.isVehicleInspectionAtSource) {
        return checkDocuments && checkInspection && !this.isDispatched;
      } else {
        return checkDocuments && checkInspection;
      }
    },
    enableReject() {
      return this.$statusUtil.getStatusIds(['truck_assigned', 'indent_arrived_due', 'reported',
        'truck_arrived', 'truck_rejected','loading_started','loading_ended']).includes(this.indent.status);
    },
    isApprove() {
      return (this.indent.flow.inspection &&
      this.indent.flow.inspection.inspection_by_transporter) || false;
    },
  },
  methods: {
    changeCheckAllInspection(val) {
      this.selectedInspection = val ? this.inspection.map(inspectionVal => inspectionVal.name) : [];
    },
    changeCheckAllInspectionDocs(val) {
      this.selectedInspectionDoc = val ?
        this.inspectionDocs.map(inspectionVal => inspectionVal.name) : [];
    },
    getInspectionData() {
      const selectedInspection = this.selectedInspection;
      const selectedInspectionDoc = this.selectedInspectionDoc;
      /* eslint-disable */
      const selectedInspectionData = this.inspection.reduce((result, ins) => {
        const key = ins.name;
        if (selectedInspection.indexOf(key) !== -1) {
          result[key] = true;
          return result;
        }
        result[key] = false;
        return result;
      }, {});
      const selectedInspectionDocData = this.inspectionDocs && this.inspectionDocs.reduce((result, ins) => {
        const key = ins.name;
        if (selectedInspectionDoc.indexOf(key) !== -1) {
          result[key] = true;
          return result;
        }
        result[key] = false;
        return result;
      }, {});
      return { selectedInspectionData, selectedInspectionDocData };
    },
    async acceptTruckInspection() {
      const data = {};
      data.accepted = true;
      const insData = this.getInspectionData();
      /* eslint-disable */
      data.inspection = insData.selectedInspectionData;
      data.documents = insData.selectedInspectionDocData;
      if(this.comments) {
        data.comments = this.comments;
      }
      try {
        const hasConfirm = await this.$PromptConfirm(this.$t('INDENT_ACCEPT_TRUCK_PROMPT'), this.$t('INDENT_INSPECTED_ACCEPTANCE'), {
          confirmButtonText: this.$t('INDENT_YES'),
          cancelButtonText: this.$t('INDENT_NO'),
          lockScroll: true,
          showClose: false,
          center: true,
          dangerouslyUseHTMLString: true,
        }).then(async () => {
             this.$emit('acceptTruckInspection', data, this.isVehicleInspectionAtSource);
          })
          .catch(() => {
            // do nothing
          });
      } catch (error) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
     async rejectInspection() {
      const data = {};
      data.accepted = false;
      const insData = this.getInspectionData();
      /* eslint-disable */
      data.inspection = insData.selectedInspectionData;
      data.documents = insData.selectedInspectionDocData;
      try {
        if (this.comments) {
          data.comments = this.comments;
          const hasConfirm = await this.$PromptConfirm(this.$t('INDENT_REJECT_TRUCK_PROMPT'), this.$t('INDENT_INSPECTED_REJECTION'), {
            confirmButtonText: this.$t('INDENT_YES'),
            cancelButtonText: this.$t('INDENT_NO'),
            lockScroll: true,
            showClose: false,
            center: true,
            dangerouslyUseHTMLString: true,
          }).then(async () => {
            this.$emit('rejectTruckInspection',  data);
            this.hasNoCommentsError = false;
          })
          .catch(() => {
            // do nothing
          });
        }
        else {
          this.hasNoCommentsError = true;
          // The inline red hint only renders for certain statuses; always surface an explicit
          // message so clicking Reject without a comment never silently no-ops.
          this.$errorMessage({ message: this.$t('INDENT_REASON_REJECTING_VEHICLE') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
    async addAttachments(file) {
        this.$emit('addAttachments', file, this.isVehicleInspectionAtSource);
    },

    async removeAttachments(file) {
      this.$emit('removeAttachments', file, this.isVehicleInspectionAtSource);
    },
  },
};
</script>